import * as betprofessor from './VerifyIdentity.styles.betprofessor';
import * as betroyale from './VerifyIdentity.styles.betroyale';
import * as fiestabet from './VerifyIdentity.styles.fiestabet';
import * as goldenrush from './VerifyIdentity.styles.goldenrush';
import * as juicybet from './VerifyIdentity.styles.juicybet';
import * as puntcity from './VerifyIdentity.styles.puntcity';
import * as puntgenie from './VerifyIdentity.styles.puntgenie';
import * as questbet from './VerifyIdentity.styles.questbet';
import * as sterlingparker from './VerifyIdentity.styles.sterlingparker';
import * as vikingbet from './VerifyIdentity.styles.vikingbet';
import * as volcanobet from './VerifyIdentity.styles.volcanobet';
import * as junglebet from './VerifyIdentity.styles.junglebet';
import * as betgalaxy from './VerifyIdentity.styles.betgalaxy';
import * as slambet from './VerifyIdentity.styles.slambet';
import * as buffalobet from './VerifyIdentity.styles.buffalobet';
import * as bet777 from './VerifyIdentity.styles.bet777';
import * as sugarcastle from './VerifyIdentity.styles.sugarcastle';
import * as goldenbet888 from './VerifyIdentity.styles.goldenbet888';
import * as gigabet from './VerifyIdentity.styles.gigabet';
import * as templebet from './VerifyIdentity.styles.templebet';
import * as chromabet from './VerifyIdentity.styles.chromabet';
import * as titanbet from './VerifyIdentity.styles.titanbet';
import * as betblast from './VerifyIdentity.styles.betblast';
import * as bet575 from './VerifyIdentity.styles.bet575';
import * as hyperbet from './VerifyIdentity.styles.hyperbet';
import * as magnumbet from './VerifyIdentity.styles.magnumbet';
import * as pyramidbet from './VerifyIdentity.styles.pyramidbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  slambet,
  buffalobet,
  bet777,
  sugarcastle,
  goldenbet888,
  gigabet,
  templebet,
  chromabet,
  titanbet,
  betblast,
  bet575,
  hyperbet,
  magnumbet,
  pyramidbet,
};
